import { __decorate } from "tslib";
import { NgModule } from 'angular-ts-decorators';
import { SystemDictionaryDirective } from './system-dictionary.directive';
import { TranslationService } from './translation.service';
var TranslationModule = (function () {
    function TranslationModule() {
    }
    TranslationModule = __decorate([
        NgModule({
            declarations: [
                SystemDictionaryDirective,
            ],
            id: 'gn.audio.support.translation',
            providers: [
                TranslationService,
            ],
        })
    ], TranslationModule);
    return TranslationModule;
}());
export { TranslationModule };
